import { createReducer, on } from "@ngrx/store";
import { DARK_THEME, LIGHT_THEME, initialUserPreferenceState } from "./user-preference.state";
import { resetUserPreferences, setUserPreferences, toggleHidePHI, toggleTheme } from "./user-preference.actions";

const _userPreferenceReducer = createReducer(
    initialUserPreferenceState,
    on(setUserPreferences, (state, action) => {
        return {
            ...state,
            theme: action?.data?.theme,
            hidePHI: action?.data?.hidePHI
        }
    }),
    on(toggleTheme, (state, action) => {
        return {
            ...state,
            theme: state.theme === LIGHT_THEME ? DARK_THEME: LIGHT_THEME
        }
    }),
    
    on(toggleHidePHI, (state, action) => {
        return {
            ...state,
            hidePHI: !state.hidePHI
        }
    }),
    on(resetUserPreferences, (state, action) => {
        return {
            ...state,
            hidePHI: initialUserPreferenceState.hidePHI // Setting hidePHI to true by default
        }
    }),
);

export const userPreferenceReducer = (state, action) => {
    return _userPreferenceReducer(state, action);
}